{
  "skip": "Skip to content",
  "nav": {
    "programs": "Programs",
    "dojos": "Dojos",
    "schedule": "Schedule",
    "pricing": "Pricing",
    "team": "Team",
    "news": "News",
    "contact": "Contact",
    "trial": "Try a class"
  },
  "hero": {
    "trial": "Book a trial class",
    "schedule": "Explore the schedule",
    "locations": "Our locations"
  },
  "programs": {
    "eyebrow": "FIND YOUR MAT",
    "title": "A program for every start.",
    "copy": "From a first roll to the competition podium, every group gets focused coaching and a clear path forward.",
    "classes": "See matching classes"
  },
  "dojos": {
    "eyebrow": "TWO DOJOS · ONE TEAM",
    "title": "Your place to train.",
    "copy": "Choose the location that works for your life. The teaching philosophy and team spirit travel with you.",
    "schedule": "View schedule",
    "map": "Open map",
    "rules": "View Dojo Rules"
  },
  "schedule": {
    "eyebrow": "THIS WEEK ON THE MATS",
    "title": "Find your next class.",
    "copy": "Filter by dojo, day and group. Times and class details are maintained independently for each location.",
    "all": "All classes",
    "adults": "Adults",
    "kids": "Kids",
    "women": "Women",
    "mma": "MMA",
    "open": "Open",
    "level": "LEVEL / GROUP",
    "coach": "COACH",
    "empty_title": "No matching class on this day.",
    "empty_copy": "Choose another day or show all classes.",
    "show_all": "Show all classes",
    "footnote": "Schedules may change during holidays and competition periods. Check the notice above or contact the team if in doubt.",
    "today": "Today",
    "beginner": "Beginner friendly"
  },
  "days": {
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "pricing": {
    "options": "options",
    "option": "option",
    "best": "Best value",
    "choose": "Choose membership",
    "ask": "Ask about this plan",
    "save": "Save"
  },
  "video": {
    "play": "Play video"
  },
  "news": {
    "eyebrow": "TEAM UPDATES",
    "title": "News from the dojos.",
    "copy": "Schedule changes, camps, seminars and community stories — all important updates live here.",
    "read": "Read update",
    "archive": "Past news",
    "close": "Close news article"
  },
  "instagram": {
    "live": "LIVE FROM INSTAGRAM",
    "follow": "FOLLOW THE TEAM",
    "view": "View post"
  },
  "contact": {
    "eyebrow": "CONTACT & LOCATIONS",
    "title": "Meet us on the mats.",
    "copy": "Both dojos are easy to reach. Open the map for directions or contact the team directly before your first visit.",
    "load_map": "Load map",
    "directions": "Open directions",
    "questions": "Questions before you come?"
  },
  "form": {
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "optional": "optional",
    "dojo": "Dojo",
    "program": "Program",
    "message": "Message",
    "placeholder": "Tell us about your experience or preferred day.",
    "success": "Thank you. Your request has been sent.",
    "mail": "Your email app is opening with the request prepared."
  },
  "faq": {
    "eyebrow": "GOOD TO KNOW",
    "title": "Questions before your first roll?",
    "copy": "Straight answers to the questions new members and parents ask most often."
  },
  "footer": {
    "instagram": "Instagram",
    "schedule": "Schedule",
    "trial": "Trial class",
    "member": "Membership questions",
    "rules": "Dojo Rules"
  },
  "mobile_cta": "Book a trial class"
}
